<template>
  <div class="bg-F6F6F6 height-full fb fb-col">
    <div class="bg-FFFFFF">
      <md-tabbar
        v-model="tabIndex"
        indicatorColor="#171A1D"
        :fixed="list.length < 4"
      >
        <md-tabbar-item
          v-for="item in list"
          :key="item.leaveType"
          :name="item.leaveType"
        >
          {{ item.leaveTypeName }}
          {{ item.leaveTypeName === '全部' ? '' : `(${item.count || 0})` }}
        </md-tabbar-item>
      </md-tabbar>
    </div>
    <div
      class="item-flex-1 scroll m-0-16"
      @scroll="handlerLoadingMore"
      v-if="(detailList || []).length"
    >
      <div
        class="bg-FFFFFF bd-radio-8 mt-12 font-28 pl-16 p-16-0s"
        v-for="(item, index) in detailList"
        :key="index"
      >
        <div class="c-171A1D-56 lh-20 p-8-0">{{ item.className }}</div>
        <div
          v-for="student in item.studentLeaveList"
          :key="student.studentDingId"
          class="fb fb-cross-start fb-main-start"
          @click="handlerClickItem(student)"
        >
          <div
            class="mr-16 w-32 h-32 avator-image"
            :class="`avator${student.gender}-1`"
          >
          </div>
          <div class="item-flex-1 bb">
            <div class="pr-16 pb-16">
              <div class="p-6-0 lh-24 fb fb-cross-center fb-main-start">
                <span
                  class="c-171A1D font-34 text-ellipsis inline-block max-w-120"
                  >{{ student.studentName }}</span
                >
                <span
                  class="iconfont pl-4"
                  v-show="student.gender"
                  :style="{
                    color: student.gender === 1 ? '#006AFE' : '#FF4D94'
                  }"
                  >{{ student.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
                >
                <span
                  class="ml-12 font-24 bd-radio-12 border-171A1D h-22 min-w-40 fb-center-center c-171A1D-60 p-0-8"
                  >{{ student.leaveTypeName }}</span
                >
              </div>

              <p class="c-171A1D-40 lh-20"
                >开始时间：{{
                  getSegTime(
                    +student.startTime,
                    +student.endTime,
                    student.leaveDurationUnit
                  )[0].replace(/\w{4}\./, '')
                }}</p
              >
              <p class="c-171A1D-40 lh-20"
                >结束时间：{{
                  getSegTime(
                    +student.startTime,
                    +student.endTime,
                    student.leaveDurationUnit
                  )[1].replace(/\w{4}\./, '')
                }}
              </p>
            </div>
            <div
              v-if="
                allowLeaveBackCertificate
                  ? student.backSchoolStatus > 0
                  : student.backSchoolStatus > 1
              "
              class="bt h-56 back-con fb fb-main-between fb-cross-center pr-12"
              @click.stop="handlerClickProve(student)"
            >
              <div class="title font-34">返校证明</div>
              <div class="status font-30">
                <span
                  :style="{
                    color:
                      BACK_SCHOOL_STATUS[+student.backSchoolStatus || 1].color
                  }"
                >
                  {{
                    BACK_SCHOOL_STATUS[+student.backSchoolStatus || 1].content
                  }}
                </span>
                <span class="iconfont c-171A1D-40">&#xe68d;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="w-fullVw item-flex-1 relative" style="min-height: 216px">
      <common-no-data class="no-record">
        <div class="no-item"></div>
        <p class="font-28 c-171A1D-40">当天暂无记录</p>
      </common-no-data>
    </div>
  </div>
</template>

<script>
import commonNoData from './commonNoData'
import { BACK_SCHOOL_STATUS } from '@/utils/constUtils'
import { timeFormat, unitDayTime } from '@/utils/comUtils'
import mixin from '../mixin'
import API from '../api'
export default {
  mixins: [mixin],
  name: '',
  components: { commonNoData },
  props: {
    dimDay: {
      type: String,
      default: timeFormat(new Date(), 'YYYY-MM-DD')
    },
    list: {
      type: Array,
      default: () => []
    },
    stateId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      BACK_SCHOOL_STATUS,
      timeFormat,
      unitDayTime,
      tabIndex: +this.stateId || 0,
      tabObj: {},
      tagIndex: '',
      detailList: [],
      isLoadDetailMore: true,
      pageNum: 1,
      pageSize: 10,
      noNeedCheckStatus: '',
      isInit: true,
      showLoading: null
    }
  },
  computed: {
    allowLeaveBackCertificate() {
      return this.$store.getters.allowLeaveBackCertificate
    }
  },
  watch: {
    dimDay() {
      !this.isInit && this.initTabList()
    },
    tabIndex(val) {
      this.handlerChangeState(
        this.list.find(item => +item.leaveType === +val),
        false,
        true,
        true
      )
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.showLoading = this.$Toast({
      type: 'loading',
      duration: 9000,
      content: '加载中···'
    })
    setTimeout(() => {
      this.isInit = false
      this.initTabList()
    }, 100)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // 初始化tab
    initTabList() {
      let _tabId = this.list.map(item => {
        return +item.leaveType
      })
      this.tabIndex = _tabId.includes(+this.tabIndex)
        ? this.tabIndex
        : _tabId[0]
      this.handlerChangeState({ leaveType: this.tabIndex }, false, true)
    },
    // 切换状态 (状态，是否是滚动，是否是初始化, 初始化标签)
    handlerChangeState(state, isScroller, initPage, initTag) {
      initPage && (this.pageNum = 1) && (this.detailList = [])
      initTag && (this.tagIndex = '')
      this.showLoading.show()
      let params = {
        ...this.commonParams,
        dimDay: this.dimDay,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      state.leaveType && (params.leaveType = state.leaveType)
      API.getLeaveDayStatDetail(params)
        .then(res => {
          this.tabIndex = state.leaveType
          const _detailList = (res || {}).classLeaveList || []
          if (_detailList.length < this.pageSize) {
            this.isLoadDetailMore = false
          } else {
            ++this.pageNum
            this.isLoadDetailMore = true
          }
          this.detailList = isScroller
            ? this.detailList.concat(_detailList)
            : _detailList
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
        .finally(_ => this.showLoading && this.showLoading.hide())
    },
    // 加载更多
    handlerLoadingMore(e) {
      let _el = e.currentTarget
      if (
        _el.scrollTop + _el.clientHeight >= _el.scrollHeight - 20 &&
        this.isLoadDetailMore
      ) {
        this.isLoadDetailMore = false
        this.handlerChangeState({ leaveType: this.tabIndex }, true, false)
      }
    },
    // 切换标签
    handlerChangeTag(item) {
      this.tagIndex = item.leaveType
      this.initTabList()
    },
    getSegTime(startTime, endTime, leaveDurationUnit) {
      if (leaveDurationUnit === 1) {
        return [
          timeFormat(new Date(startTime), 'MM.DD hh:mm'),
          timeFormat(new Date(endTime), 'MM.DD hh:mm')
        ]
      } else {
        return unitDayTime(startTime, endTime, 'YYYY.MM.DD hhmm')
      }
    },
    handlerClickItem(item) {
      this.$emit('click', item)
    },
    handlerClickProve(item) {
      this.$emit('clickProve', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.head-img {
  height: 36px;
  width: 36px;
  margin-right: 12px;
  img {
    height: 36px;
    width: 36px;
    border-radius: 50%;
  }
}
.head-img-name {
  margin-right: 12px;
  height: 36px;
  width: 36px;
  color: #ffffff;
  background: #006afe;
  border-radius: 50%;
}
.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 1.5px;
}
.fixed-class {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
}
.scroll-x {
  overflow-x: scroll;
}
.pt-110 {
  padding-top: 110px;
}
.no-record {
  .no-item {
    width: 180px;
    height: 180px;
    background: url(~@/assets/images/no-data.png) no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>
